interface ActionButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  onClick?: () => void;
  className?: string;
  iconSrc?: string;
  iconClass?: string;
  iconPosition?: 'left' | 'right';
  as?: 'button' | 'a';
  href?: string;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  variant = 'primary',
  onClick,
  className = '',
  iconSrc = '/icons/Up-right.svg',
  iconClass = 'h-4 w-4',
  iconPosition = 'right',
  as = 'button',
  href,
}) => {
  const baseClasses =
    'flex items-center gap-2 rounded-full px-8 py-2 font-medium text-white transition-all duration-200 hover:scale-105 active:scale-95';

  const variantClasses = {
    primary: 'bg-[#3885FF] hover:bg-blue-600',
    secondary: 'border border-blue-500 hover:bg-blue-600',
  };

  const content = (
    <>
      {iconPosition === 'left' && <img src={iconSrc} alt='Arrow icon' className={iconClass} />}
      {children}
      {iconPosition === 'right' && <img src={iconSrc} alt='Arrow icon' className={iconClass} />}
    </>
  );

  if (as === 'a') {
    return (
      <a href={href} className={`${baseClasses} ${variantClasses[variant]} ${className}`}>
        {content}
      </a>
    );
  }

  return (
    <button className={`${baseClasses} ${variantClasses[variant]} ${className}`} onClick={onClick}>
      {content}
    </button>
  );
};

export default ActionButton;
